import { Switch } from '@/components/ui/switch';
import { FOR_PROTOCOL_NOTE } from '../../constants';

interface MarkAsSopToggleProps {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
}

// Shared toggle shown under a pending upload in the Add Documents / Add Website Links dialogs.
export function MarkAsSopToggle({ checked, onCheckedChange }: MarkAsSopToggleProps) {
  return (
    <div className='flex items-center justify-between gap-4'>
      <div>
        <p className='text-xs font-medium'>Use for a protocol</p>
        <p className='text-[11px] text-muted-foreground'>{FOR_PROTOCOL_NOTE}</p>
      </div>
      <Switch checked={checked} onCheckedChange={onCheckedChange} />
    </div>
  );
}
